// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BulkGlobalPlanTagsModalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BulkGlobalPlanTagsModalQuery = { __typename?: 'Query', globalPlanTags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string }> };

export type BulkGlobalPlanTagsMutationVariables = Types.Exact<{
  input: Array<Types.SaveGlobalPlanTagInput> | Types.SaveGlobalPlanTagInput;
}>;


export type BulkGlobalPlanTagsMutation = { __typename?: 'Mutation', bulkSaveGlobalPlanTags: { __typename?: 'BulkSaveGlobalPlanTagsResult', globalPlanTags: Array<{ __typename?: 'GlobalPlanTag', id: string, name: string, tasks: Array<{ __typename?: 'GlobalPlanTask', id: string }> }> } };


export const BulkGlobalPlanTagsModalDocument = gql`
    query BulkGlobalPlanTagsModal {
  globalPlanTags {
    id
    name
  }
}
    `;

/**
 * __useBulkGlobalPlanTagsModalQuery__
 *
 * To run a query within a React component, call `useBulkGlobalPlanTagsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkGlobalPlanTagsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkGlobalPlanTagsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useBulkGlobalPlanTagsModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BulkGlobalPlanTagsModalQuery, BulkGlobalPlanTagsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkGlobalPlanTagsModalQuery, BulkGlobalPlanTagsModalQueryVariables>(BulkGlobalPlanTagsModalDocument, options);
      }
export function useBulkGlobalPlanTagsModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkGlobalPlanTagsModalQuery, BulkGlobalPlanTagsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkGlobalPlanTagsModalQuery, BulkGlobalPlanTagsModalQueryVariables>(BulkGlobalPlanTagsModalDocument, options);
        }
export function useBulkGlobalPlanTagsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkGlobalPlanTagsModalQuery, BulkGlobalPlanTagsModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkGlobalPlanTagsModalQuery, BulkGlobalPlanTagsModalQueryVariables>(BulkGlobalPlanTagsModalDocument, options);
        }
export type BulkGlobalPlanTagsModalQueryHookResult = ReturnType<typeof useBulkGlobalPlanTagsModalQuery>;
export type BulkGlobalPlanTagsModalLazyQueryHookResult = ReturnType<typeof useBulkGlobalPlanTagsModalLazyQuery>;
export type BulkGlobalPlanTagsModalSuspenseQueryHookResult = ReturnType<typeof useBulkGlobalPlanTagsModalSuspenseQuery>;
export type BulkGlobalPlanTagsModalQueryResult = Apollo.QueryResult<BulkGlobalPlanTagsModalQuery, BulkGlobalPlanTagsModalQueryVariables>;
export const BulkGlobalPlanTagsDocument = gql`
    mutation BulkGlobalPlanTags($input: [SaveGlobalPlanTagInput!]!) {
  bulkSaveGlobalPlanTags(input: $input) {
    globalPlanTags {
      id
      name
      tasks {
        id
      }
    }
  }
}
    `;
export type BulkGlobalPlanTagsMutationFn = Apollo.MutationFunction<BulkGlobalPlanTagsMutation, BulkGlobalPlanTagsMutationVariables>;

/**
 * __useBulkGlobalPlanTagsMutation__
 *
 * To run a mutation, you first call `useBulkGlobalPlanTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkGlobalPlanTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkGlobalPlanTagsMutation, { data, loading, error }] = useBulkGlobalPlanTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkGlobalPlanTagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkGlobalPlanTagsMutation, BulkGlobalPlanTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkGlobalPlanTagsMutation, BulkGlobalPlanTagsMutationVariables>(BulkGlobalPlanTagsDocument, options);
      }
export type BulkGlobalPlanTagsMutationHookResult = ReturnType<typeof useBulkGlobalPlanTagsMutation>;
export type BulkGlobalPlanTagsMutationResult = Apollo.MutationResult<BulkGlobalPlanTagsMutation>;
export type BulkGlobalPlanTagsMutationOptions = Apollo.BaseMutationOptions<BulkGlobalPlanTagsMutation, BulkGlobalPlanTagsMutationVariables>;